import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { ModalFullCentered, CloseLateralModalSimple } from '../../../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import TableSellTicketListingTPV from './TableSellTicketListingTPV'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { EmployeesPayload } from '../../../../../../../../utils/reducers/company/employees'
import { WorkingCenterPayload } from '../../../../../../../../utils/reducers/company/workingCenters'
import { useCallback, useState } from 'react'
import { TabItems, SwitchButton } from '../../../../../../../../baseComponents/Button/SwitchButton'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import TableSellTicketRefundListingTPV from './TableSellTicketRefundListingTPV'
import { HandleSellTicketFncsProps } from '../types'
import { TPVOrderData } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'

type ModalSellTicketListingTPVProps = ModalEditComponentProps & ReduxModalSellTicketListingTPV & HandleSellTicketFncsProps & {
    completeData: TPVOrderData
}

const ModalSellTicketListingTPV: React.FC<ModalSellTicketListingTPVProps> = ({ handleSelectTicket, handleSelectTicketRefund, ...rest }) => {
    const { activeTab, changeTab } = useModalSellTicketListingTPVLogic()
      const items: TabItems[] = [
            {
                element: <TwinTrans transKey={'tickets'}>Tickets</TwinTrans>
            },
            {
                element: <TwinTrans transKey={'refunds'}>Devoluciones</TwinTrans>
            },
        ]
    
    return (
        <ModalFullCentered opened={true} setOpened={() => rest.setOpened(null)} className='shortcut_modal'>
            <div className='flex items-baseline'>
                <CloseLateralModalSimple onClose={() => rest.setOpened(null)} />
                <div className=''>
                    <SwitchButton className='ml-30' items={items} onClick={changeTab} active={activeTab} />
                </div>
            </div>
            {activeTab === 0 ?
                <TableSellTicketListingTPV setTableInstance={() => { }} userPermissions={getUserPermissions('sell.tickets') || { n: 1, permission: 'read' }} tableInstance={null} {...rest} setOpened={() => rest.setOpened(null)} onRowClick={(value) => handleSelectTicket(value)} handleSelectTicket={handleSelectTicket} />
                : <TableSellTicketRefundListingTPV setTableInstance={() => { }} userPermissions={getUserPermissions('sell.refundTickets') || { n: 1, permission: 'read' }} tableInstance={null} {...rest} setOpened={() => rest.setOpened(null)} onRowClick={(value) => handleSelectTicketRefund(value)} handleSelectTicketRefund={handleSelectTicketRefund} />}
        </ModalFullCentered>
    )
}

const useModalSellTicketListingTPVLogic = () => {
    const [activeTab, setActiveTab] = useState<number>(0)
    const changeTab = useCallback((val: number) => {
        setActiveTab(val)
    }, [setActiveTab])
    return { activeTab, changeTab }
}


const modalSellTicketListingTPVDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
}

type ReduxModalSellTicketListingTPV = ConnectedProps<typeof modalSellTicketListingTPVConnect>
const mapModalSellTicketListingTPVConnector = (state: AllReduxPayloads) => ({ employees: state.employees, workingCenters: state.workingCenters })
const modalSellTicketListingTPVConnect = connect(mapModalSellTicketListingTPVConnector, modalSellTicketListingTPVDispatch)
const modalSellTicketListingTPVLoading = withLoading(ModalSellTicketListingTPV, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])
const ModalSellTicketListingTPVConnect = modalSellTicketListingTPVConnect(modalSellTicketListingTPVLoading)

export default ModalSellTicketListingTPVConnect
